import React from 'react';
import LegalPage from '../components/LegalPage';
import { DEFAULT_TERMS } from '../lib/pageDefaults';

export default function TermsPage() {
  return <LegalPage pageKey="terms" defaults={DEFAULT_TERMS} />;
}
